var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNewNoNextEvents = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 85.95 92.99",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e63f7;}.cls-2{fill:#ffc466;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.06px;}.cls-2,.cls-3{stroke:#2e63f7;}.cls-3{fill:none;stroke-miterlimit:10;stroke-width:1.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.65,8.39H24.29a.79.79,0,0,1,0-1.57H61.65a.79.79,0,0,1,0,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.62,93H20.79C12.11,93,0,84.29,0,70.12V13.34A6.44,6.44,0,0,1,6.33,6.82h11a.78.78,0,0,1,0,1.56h-11a4.88,4.88,0,0,0-4.77,5V70.12c0,13.2,11.2,21.31,19.23,21.31H79.62a4.86,4.86,0,0,0,4.76-5V13.34a4.86,4.86,0,0,0-4.76-4.95h-11a.79.79,0,0,1,0-1.57h11A6.44,6.44,0,0,1,86,13.34V86.48A6.43,6.43,0,0,1,79.62,93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,92.47a.78.78,0,0,1-.78-.78V78.42a4.7,4.7,0,0,0-4.6-4.79H1.88a.78.78,0,1,1,0-1.56H13.63a6.26,6.26,0,0,1,6.16,6.35V91.69A.78.78,0,0,1,19,92.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.79,17a4.34,4.34,0,0,1-4.28-4.4V4.4a4.28,4.28,0,1,1,8.56,0v8.19A4.34,4.34,0,0,1,20.79,17Zm0-15.43A2.78,2.78,0,0,0,18.07,4.4v8.19a2.72,2.72,0,1,0,5.44,0V4.4A2.78,2.78,0,0,0,20.79,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.15,17a4.34,4.34,0,0,1-4.28-4.4V4.4a4.28,4.28,0,1,1,8.56,0v8.19A4.34,4.34,0,0,1,65.15,17Zm0-15.43A2.78,2.78,0,0,0,62.43,4.4v8.19a2.72,2.72,0,1,0,5.44,0V4.4A2.78,2.78,0,0,0,65.15,1.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.3,
    y: 40.59,
    width: 10.08,
    height: 8.68,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.83,49.38h-9a.67.67,0,0,1-.66-.66V41.13a.67.67,0,0,1,.66-.66h9a.67.67,0,0,1,.67.66v7.59A.67.67,0,0,1,21.83,49.38Zm-9-8.68a.44.44,0,0,0-.43.43v7.59a.44.44,0,0,0,.43.43h9a.43.43,0,0,0,.43-.43V41.13a.43.43,0,0,0-.43-.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.3,
    y: 54.85,
    width: 10.08,
    height: 8.68,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.83,63.64h-9a.67.67,0,0,1-.66-.66V55.39a.67.67,0,0,1,.66-.66h9a.67.67,0,0,1,.67.66V63A.67.67,0,0,1,21.83,63.64Zm-9-8.68a.44.44,0,0,0-.43.43V63a.44.44,0,0,0,.43.43h9a.43.43,0,0,0,.43-.43V55.39a.43.43,0,0,0-.43-.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.8,
    y: 26.33,
    width: 10.08,
    height: 8.68,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.34,35.12h-9a.67.67,0,0,1-.67-.66V26.88a.67.67,0,0,1,.67-.67h9a.66.66,0,0,1,.66.67v7.58A.66.66,0,0,1,39.34,35.12Zm-9-8.68a.44.44,0,0,0-.43.44v7.58a.43.43,0,0,0,.43.43h9a.43.43,0,0,0,.43-.43V26.88a.44.44,0,0,0-.43-.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.84,
    y: 26.33,
    width: 10.08,
    height: 8.68,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.38,35.12h-9a.66.66,0,0,1-.66-.66V26.88a.66.66,0,0,1,.66-.67h9a.67.67,0,0,1,.67.67v7.58A.67.67,0,0,1,22.38,35.12Zm-9-8.68a.44.44,0,0,0-.43.44v7.58a.43.43,0,0,0,.43.43h9a.43.43,0,0,0,.43-.43V26.88a.44.44,0,0,0-.43-.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.8,
    y: 40.59,
    width: 10.08,
    height: 8.68,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.34,49.38h-9a.67.67,0,0,1-.67-.66V41.13a.67.67,0,0,1,.67-.66h9a.66.66,0,0,1,.66.66v7.59A.66.66,0,0,1,39.34,49.38Zm-9-8.68a.43.43,0,0,0-.43.43v7.59a.43.43,0,0,0,.43.43h9a.43.43,0,0,0,.43-.43V41.13a.43.43,0,0,0-.43-.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.8,
    y: 54.85,
    width: 10.08,
    height: 8.68,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.34,63.64h-9a.67.67,0,0,1-.67-.66V55.39a.67.67,0,0,1,.67-.66h9a.66.66,0,0,1,.66.66V63A.66.66,0,0,1,39.34,63.64Zm-9-8.68a.43.43,0,0,0-.43.43V63a.43.43,0,0,0,.43.43h9a.43.43,0,0,0,.43-.43V55.39a.43.43,0,0,0-.43-.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.31,
    y: 26.33,
    width: 10.08,
    height: 8.68,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.84,35.12h-9a.67.67,0,0,1-.67-.66V26.88a.67.67,0,0,1,.67-.67h9a.67.67,0,0,1,.67.67v7.58A.67.67,0,0,1,56.84,35.12Zm-9-8.68a.44.44,0,0,0-.44.44v7.58a.44.44,0,0,0,.44.43h9a.43.43,0,0,0,.43-.43V26.88a.44.44,0,0,0-.43-.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.31,
    y: 40.59,
    width: 10.08,
    height: 8.68,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.84,49.38h-9a.67.67,0,0,1-.67-.66V41.13a.67.67,0,0,1,.67-.66h9a.67.67,0,0,1,.67.66v7.59A.67.67,0,0,1,56.84,49.38Zm-9-8.68a.44.44,0,0,0-.44.43v7.59a.44.44,0,0,0,.44.43h9a.43.43,0,0,0,.43-.43V41.13a.43.43,0,0,0-.43-.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 47.31,
    y: 54.85,
    width: 10.08,
    height: 8.68,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.84,63.64h-9a.67.67,0,0,1-.67-.66V55.39a.67.67,0,0,1,.67-.66h9a.67.67,0,0,1,.67.66V63A.67.67,0,0,1,56.84,63.64Zm-9-8.68a.44.44,0,0,0-.44.43V63a.44.44,0,0,0,.44.43h9a.43.43,0,0,0,.43-.43V55.39a.43.43,0,0,0-.43-.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.87,
    y: 54.85,
    width: 10.08,
    height: 8.68,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.41,63.64h-9a.67.67,0,0,1-.67-.66V55.39a.67.67,0,0,1,.67-.66h9a.67.67,0,0,1,.66.66V63A.67.67,0,0,1,74.41,63.64Zm-9-8.68a.43.43,0,0,0-.43.43V63a.43.43,0,0,0,.43.43h9a.44.44,0,0,0,.43-.43V55.39a.44.44,0,0,0-.43-.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.81,
    y: 26.33,
    width: 10.08,
    height: 8.68,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.35,35.12h-9a.66.66,0,0,1-.66-.66V26.88a.66.66,0,0,1,.66-.67h9a.66.66,0,0,1,.66.67v7.58A.66.66,0,0,1,74.35,35.12Zm-9-8.68a.44.44,0,0,0-.43.44v7.58a.43.43,0,0,0,.43.43h9a.43.43,0,0,0,.43-.43V26.88a.44.44,0,0,0-.43-.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.81,
    y: 40.59,
    width: 10.08,
    height: 8.68,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.35,49.38h-9a.66.66,0,0,1-.66-.66V41.13a.66.66,0,0,1,.66-.66h9a.66.66,0,0,1,.66.66v7.59A.66.66,0,0,1,74.35,49.38Zm-9-8.68a.43.43,0,0,0-.43.43v7.59a.43.43,0,0,0,.43.43h9a.43.43,0,0,0,.43-.43V41.13a.43.43,0,0,0-.43-.43Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 46.67,
    y1: 74.41,
    x2: 74.29,
    y2: 74.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 46.67,
    y1: 81.36,
    x2: 74.29,
    y2: 81.36
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewNoNextEvents, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/newNoNextEvents.14d1d430.svg";
export { ForwardRef as ReactComponent };